import script from "./CD4UModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CD4UModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__